import { useState, type FormEvent } from "react";
import {
  Button,
  Card,
  PasswordInput,
  Stack,
  Group,
} from "@mantine/core";
import { notifications } from "@mantine/notifications";
import { authApi } from "../../api/auth";
import { PageHeader } from "../../components/common/PageHeader";
import { errorMessage } from "../../lib/axios";

export function ChangePasswordPage() {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const mismatch = confirm.length > 0 && next !== confirm;
  const tooShort = next.length > 0 && next.length < 6;

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    if (mismatch || tooShort) return;
    setLoading(true);
    try {
      await authApi.updatePassword(current, next);
      notifications.show({ color: "green", message: "Password updated" });
      setCurrent("");
      setNext("");
      setConfirm("");
    } catch (err) {
      notifications.show({ color: "red", message: errorMessage(err) });
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      <PageHeader title="Change password" subtitle="Update your admin password" />
      <Card withBorder radius="md" padding="lg" maw={460}>
        <form onSubmit={handleSubmit}>
          <Stack>
            <PasswordInput
              label="Current password"
              value={current}
              onChange={(e) => setCurrent(e.currentTarget.value)}
              required
            />
            <PasswordInput
              label="New password"
              value={next}
              onChange={(e) => setNext(e.currentTarget.value)}
              required
              error={tooShort ? "At least 6 characters" : undefined}
            />
            <PasswordInput
              label="Confirm new password"
              value={confirm}
              onChange={(e) => setConfirm(e.currentTarget.value)}
              required
              error={mismatch ? "Passwords don’t match" : undefined}
            />
            <Group justify="flex-end">
              <Button
                type="submit"
                loading={loading}
                disabled={!current || !next || mismatch || tooShort}
              >
                Update password
              </Button>
            </Group>
          </Stack>
        </form>
      </Card>
    </>
  );
}
